"use strict";

import "core-js/modules/es.array.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { createContext, useContext, useEffect, useMemo, useState } from 'react';
import { getFromStore, setToStore } from '~/src/helpers/store';
import { jsx as _jsx } from "react/jsx-runtime";
const launcherContext = /*#__PURE__*/createContext(null);
export const useLauncherContext = () => useContext(launcherContext);
export const LauncherProvider = ({
  children
}) => {
  const [make, setMake] = useState(getFromStore('homepage-vehicle-make'));
  const [model, setModel] = useState(getFromStore('homepage-vehicle-model'));
  useEffect(() => {
    setToStore('homepage-vehicle-make', make);
  }, [make]);
  useEffect(() => {
    setToStore('homepage-vehicle-model', model);
  }, [model]);
  return /*#__PURE__*/_jsx(launcherContext.Provider, {
    value: useMemo(() => ({
      make,
      setMake,
      model,
      setModel
    }), [make, model]),
    children: children
  });
};